<template>
    <main class="layout-main">
        <transition 
            name="slide-step" 
            mode="out-in"
        >
            <router-view />
        </transition>
    </main>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.layout-main {
    // $slide-duration: .350s;
    // $slide-distance: 100px;

    $slide-duration: .350s;
    $slide-duration-leave: .150s;
    $slide-distance: 40px;

    overflow: hidden;
    min-height: 300px;

    .slide-step-enter,
    .slide-step-enter-active,
    .slide-step-leave,
    .slide-step-leave-active {
        @include transition(all $slide-duration ease-out);
    }

    .slide-step-enter-active {
        @include transform(translateX(#{$slide-distance}));
        opacity: 0;
    }

    .slide-step-enter-to,
    .slide-step-leave {
        @include transform-none();
        opacity: 1;
    }

    .slide-step-leave-active {
        // @include transform(translateX(-#{$slide-distance}));
        @include transition(all $slide-duration-leave ease-in);
        opacity: 0;
    }
}
</style>